import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppNoLinks from './AppNoLinks';
import ReduxToastr from 'react-redux-toastr';
import './index.scss';
import './toastr.scss';
import { Provider } from 'react-redux';
import configureStore from './store';
import * as api from './api';
import { Switch,  Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { AccessibilityNotifications as SsgAccessibilityNotifications } from '@social-solutions/ssg-forms';
import { LoginComponent } from './login';
import { ResetPasswordComponent, SetPasswordComponent } from './acct';
import { requireAuthentication, AuthTokenObserver, HeartbeatComponent } from './auth';
import { TitleAnnouncer } from './layout';
import { PublicHelpPageComponent } from './help';
import { AccessibilityNotificationComponent, accessibilityNotificationsEmitter } from './common';
import { IntakeFormComponent, IntakeFormSubmitResultComponent } from './intake';
import { SurveyComponent } from './survey';
import { requireTenant, tenantHelpers, integrationTypes } from './tenantInfo';
import { featureHelpers } from './features';
import { history } from './history';
import { requireFeature, features } from './features';
import { track, trackingObserver } from './tracking';
import OptOutComponent from './acct/opt-out/opt-out.component';
import ConfirmedComponent from './acct/opt-out/confirmed-component';

console.log("Initializing " + process.env.NODE_ENV + " environment");

const urlParams = new URLSearchParams(window.location.search);
const authTokenParam = urlParams.get('authToken');
if (authTokenParam) {
  localStorage.setItem('authToken', authTokenParam);
  window.history.replaceState({}, document.title, window.location.pathname);
}
const bonterraLogoScript = document.createElement('script');
bonterraLogoScript.type = 'module';
bonterraLogoScript.src = 'https://cdn.bonterra.network/stitch/helpers/bonterra-logo/bonterra-logo.js';
document.head.appendChild(bonterraLogoScript);

const store = configureStore({});

api.config.store = store;
accessibilityNotificationsEmitter.store = store;
featureHelpers.store = store;
tenantHelpers.store = store;
store.subscribe(AuthTokenObserver(store));
store.subscribe(trackingObserver(store));
track.init();

// redirect to required protocol if using incorrect one
const requiredProtocol = process.env.REQUIRED_PROTOCOL;
if (window.location.protocol !== `${requiredProtocol}:`) {
  const { host, pathname, search } = window.location;
  window.location = `${requiredProtocol}://${host}${pathname}${search}`;
}

ReactDOM.render(
  <Provider store={store}>
    <div>
      <TitleAnnouncer/>
      <HeartbeatComponent/>
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/public-help" component={requireTenant(requireFeature(PublicHelpPageComponent, [features.apricotPortal], [integrationTypes.apricot]))} />
          <Route exact path="/login" component={requireTenant(requireFeature(LoginComponent, [features.apricotPortal], [integrationTypes.apricot]))} />
          <Route exact path="/reset-password" component={requireTenant(requireFeature(ResetPasswordComponent, [features.apricotPortal], [integrationTypes.apricot]))} />
          <Route exact path="/opt-out/" component={requireTenant(OptOutComponent)}/>
          <Route exact path="/confirmed/" component={requireTenant(ConfirmedComponent)}/>
          <Route exact path="/set-password" component={requireTenant(requireFeature(SetPasswordComponent, [features.apricotPortal], [integrationTypes.apricot]))} />
          <Route exact path="/apricot-intake/:id" component={requireTenant(requireFeature(IntakeFormComponent, [features.intake]))} />
          <Route exact path="/apricot-intake/:id/results" component={requireTenant(requireFeature(IntakeFormSubmitResultComponent, [features.intake]))} />
          <Route exact path="/intake/:id" component={requireTenant(requireFeature(IntakeFormComponent, [features.intake]))} />
          <Route exact path="/intake/:id/results" component={requireTenant(IntakeFormSubmitResultComponent)} />
          <Route exact path="/survey" component={requireTenant(requireFeature(SurveyComponent, [features.directMessages]))} />
          <Route path="/sites/:siteId/programs/:programId/forms/:touchpointFormId/"  component={requireTenant(requireFeature(requireAuthentication(AppNoLinks), [features.apricotPortal], [integrationTypes.apricot]))}/>
          <Route path="/requestappointments"  component={requireTenant(requireFeature(requireAuthentication(AppNoLinks), [features.apricotPortal], [integrationTypes.apricot]))}/>
          <Route path="/" component={requireTenant(requireFeature(requireAuthentication(App), [features.apricotPortal], [integrationTypes.apricot]))} />
        </Switch>
      </ConnectedRouter>
      <div aria-live="polite">
        <ReduxToastr
          timeOut={6000}
          newestOnTop={false}
          preventDuplicates={true}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar />
      </div>
      <AccessibilityNotificationComponent/>
      <SsgAccessibilityNotifications />
    </div>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// src/index.js